import { InformationCircleIcon, MagnifyingGlassIcon, MinusCircleIcon } from '@heroicons/react/24/outline'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import PopupCustomer from '../../components/PopupCustomer'

function AllProducts() {

    const [kunden, setKunden] = useState([])
    const [kundenPaged, setKundenPaged] = useState([])
    const [pageSize, setPageSize] = useState(10)
    const [pageNumber, setPageNumber] = useState(1) 
    const [query, setQuery] = useState("")
    const [product, setProduct] = useState({});
    const [modal, setModalShow] = useState(false)
    const [reload, setReload] = useState(false)

    const [customer_id, setCustomerId] = useState("")

    let searchArray = query.toLowerCase().trim().split(" ");
      
  const formatter = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
  });


  useEffect(() => {
    try{
      axios.get("https://dealersonly.parts/beta/api/admin/get-all-products")
      .then((res)=>{
          setKunden(res.data)
      })

    }catch(error){
          console.log(error)
    }
    return () => {
      // Cleanup function to clear data
      setKunden([]);
    };
  
  }, [reload])

  const deleteProduct = (id) => {
    axios.post("https://dealersonly.parts/beta/api/products/delete", {id: id},{
        
    }).then(res => {
        setReload(!reload)
      })
      .catch((error) => {
        console.log(error);
      })
  }


  return (
    <>
    <div className="shadow sm:overflow-hidden sm:rounded-md">
    <div className="bg-white py-6 px-4 sm:p-6">
                       <div>
                       <h2 id="payment-details-heading" className="text-lg font-medium leading-6 text-gray-900">
                         Alle Produkte
                       </h2>
                       <p className="mt-1 text-sm text-gray-500">
                         Eine Übersicht aller eingestellten Produkte.
                       </p>
                     </div>
      </div>
      <div className="p-2 mt-8 flow-root">
        <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
                <div className="flex flex-1 items-center justify-start lg:justify-end bg-gray-50 p-2">
                    <div className="w-full max-w-lg lg:max-w-xs">
                    <label htmlFor="search" className="sr-only">
                        Suchen
                    </label>
                    <div className="relative">
                        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                        <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                        </div>
                        <input
                        id="search"
                        name="search"
                        onChange={(e)=>{setQuery(e.target.value);setPageNumber(1)}}
                        className="block w-full rounded-md border-0 bg-white py-1.5 pl-10 pr-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        placeholder="Parts durchsuchen"
                        type="search"
                        value={query}
                        />
                    </div>
                    </div>
                </div>
              <table className="min-w-full divide-y divide-gray-300">
                
                <thead className="bg-gray-50">
                  <tr>
                    <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                      <span className="sr-only">Edit</span>
                    </th>
                    <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                      Bezeichnung
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                      Anbieter
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                      Preis
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                      Status
                    </th>
                    
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {kunden.filter((kunde)=> searchArray.every(el=> (kunde.title).toLowerCase().includes(el) || (kunde.description).toLowerCase().includes(el)))
                  .slice(pageNumber === 1 ? pageNumber -1 :pageNumber*pageSize-10, pageNumber * pageSize)
                  .map((person) => {
                    return (
                    <tr key={person._id}>
                      <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                        <button type='button' onClick={()=>{deleteProduct(person._id);}} className="text-indigo-600 hover:text-indigo-900">
                          <MinusCircleIcon className='w-5 h-5 text-red-500'/><span className="sr-only">, {person.title}</span>
                        </button>
                      </td>  
                      <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                      {person.title}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500"><button type='button' onClick={()=>{setCustomerId(person.vendorHandle); setModalShow(true)}}>{person.vendor}</button></td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-ellipsis overflow-hidden max-w-xs">{formatter.format(person.price)}</td>
                      <td className="px-3 py-4 flex gap-x-3">{person.active?

                      <div className="rounded-md py-1 px-2 text-xs font-medium ring-1 ring-inset text-green-700 bg-green-50 ring-green-600/20">Aktiv</div>:
                      <div className="rounded-md py-1 px-2 text-xs font-medium ring-1 ring-inset text-red-700 bg-red-50 ring-red-600/10">Inaktiv</div>
                      
                      }</td>
                      
                    </tr>
                  )}
                  
                  )}
                </tbody>
                
              </table>
              <nav
                className="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6"
                aria-label="Pagination"
                >
                <div className="hidden sm:block">
                    <p className="text-sm text-gray-700">
                    Zeige Eintrag <span className="font-medium">{pageNumber === 1 ? pageNumber:pageNumber*pageSize-10+1}</span> bis <span className="font-medium">{pageSize * pageNumber}</span> von{' '}
                    <span className="font-medium">{kunden.length}</span> Parts
                    </p>
                </div>
                <div className="flex flex-1 justify-between sm:justify-end">
                    <button
                    type='button'
                    onClick={()=>{setPageNumber(pageNumber===1?1:pageNumber -1)}}
                    className="relative inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:outline-offset-0"
                    >
                    Vorherige
                    </button>
                    <button
                    onClick={()=>{setPageNumber(pageNumber +1 )}}
                    type='button'
                    className="relative ml-3 inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:outline-offset-0"
                    >
                    Nächste
                    </button>
                </div>
                </nav>
            </div>
          </div>
        </div>
      </div>
      </div>
      <PopupCustomer 
      open={modal}
      onHide={()=>{setModalShow(false)}}
      handle={customer_id}
      />  
      </>
    
  )
}

export default AllProducts